import { Component } from '@angular/core';

@Component({
  selector: 'app-why-chose-egypt',
  templateUrl: './why-chose-egypt.component.html',
  styleUrl: './why-chose-egypt.component.scss'
})
export class WhyChoseEgyptComponent {
countryData = [
  { label: 'علم الدولة', value: 'assets/whyEgypt/egyptF.png', type: 'image' },
  { label: 'اللغة الرسمية', value: 'العربية' },
  { label: 'اللغات الأجنبية', value: 'تنتشر الانجليزية والفرنسية على نطاق واسع بين المتعلمين' },
  { label: 'العاصمة', value: 'القاهرة' },
  { label: 'أكبر المدن', value: 'القاهرة، الإسكندرية، الجيزة، بورسعيد، السويس، الغردقة، الأقصر، شرم الشيخ' },
  { label: 'نظام الحكم', value: 'جمهورية' },
  { label: 'رئيس الدولة', value: 'الرئيس : عبد الفتاح السيسي' },
  { label: 'رئيس الحكومة', value: 'رئيس الوزراء : مصطفى مدبولي' },
  { label: 'البرلمان', value: 'رئيس مجلس النواب : السيد المستشار الدكتور حنفي جبالي' },
  { label: 'التقسيم الإداري', value: '27 محافظة' },
  { label: 'العيد القومي', value: '23 يوليو (عيد الثورة)، 6 أكتوبر (عيد النصر)، 25 يناير (ثورة الشباب/عيد الشرطة)' },
  { label: 'تعداد سكان', value: '105.9 مليون نسمة (يناير 2024)' },
  { label: 'المساحة', value: '1.002 مليون كم²' },
  { label: 'متوسط معدل النمو الأقتصادي', value: '3.8% (العام المالي 2022/2023)' },
  { label: 'المنطقة الزمنية', value: 'GMT +2 hrs' },
  { label: 'متوسط الناتج المحلي الإجمالي بالأسعار الجارية', value: '10.2 تريليون جنيه (العام المالي 2022/2023)' },
  { label: 'متوسط معدل التضخم', value: '24.8% (العام المالي 2022/2023)' },
  { label: 'معدل البطالة', value: '7.2% (العام المالي 2022/2023)' },
  { label: 'صافي الاحتياطات الدولية', value: '34.8 مليار دولار (يونيو 2023)' },
  { label: 'متوسط الاستثمارات الخاصة', value: '499.2 مليار جنيه (العام المالي 2022/2023)' },
  { label: 'متوسط صافي تدفقات الاستثمار الأجنبي المباشر', value: '10 مليار دولار (العام المالي 2022/2023)' },
  { label: 'متوسط سعر الصرف', value: '30.9 (جنيه/دولار) يونيو 2023' },
  { label: 'الصادرات', value: '34.9 مليار دولار (2021/2022)' },
  { label: 'عدد المطارات المحلية والدولية', value: '27' },
  { label: 'عدد المواني التجارية', value: '18' },
  { label: 'شبكة الطرق التي تم تطويرها', value: '165.5 ألف كم (عام 2023)' },
  { label: 'طول شبكة السكك الحديدية', value: '9570 كم و 705 محطة (عام 2022)' },
  { label: 'مترو الأنفاق', value: '3 خطوط مترو الأنفاق و 94 محطة مترو' },
  { label: 'خط مونوريل', value: '2 خط و 35 محطة' },
  { label: 'القطار الكهربائي الخفيف', value: '19 محطة' },
  { label: 'القطار الكهربائي السريع', value: '60 محطة' },
  { label: 'الطاقة المولدة والمشتراه', value: '216.3 مليار ك.و.س (2022/2023)' },
  { label: 'زيت خام و متكثفات', value: '28 مليون طن (عام 2023)' },
  { label: 'إنتاج الغاز الطبيعي', value: '45 مليون طن (عام 2023)' },
  { label: 'إنتاج غاز البوتاجاز', value: '1 مليون طن (عام 2023)' },
];

}
